// iciciQr.js
//
// QR drawing for the ICICI UPI flow. ICICI's generateQR API returns only the
// UPI intent string ("upi://pay?pa=...&am=250.00&cu=INR") — not an image —
// so the QR has to be encoded client-side.
//
// The encoder is pulled from CDN the same way razorpayCheckout.js pulls
// Razorpay's checkout.js, since there's no QR package in package.json. The
// encoding itself happens entirely in-browser, so the UPI string (which
// carries the payee VPA and the amount) never leaves the till.
//
// If a bundled dependency is preferred later — worth doing, since a CDN
// outage currently costs you the QR — only the two functions below need to
// change; nothing in IciciQrDialog.js knows where the encoder came from.

const QR_SCRIPT_SRC = 'https://cdnjs.cloudflare.com/ajax/libs/qrcodejs/1.0.0/qrcode.min.js';

let scriptLoadPromise = null;

export function loadQrEncoder() {
    if (window.QRCode) return Promise.resolve();
    if (scriptLoadPromise) return scriptLoadPromise;

    scriptLoadPromise = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = QR_SCRIPT_SRC;
        script.onload = () => resolve();
        script.onerror = () => {
            scriptLoadPromise = null; // allow retry on next call
            reject(new Error('Failed to load QR encoder script'));
        };
        document.body.appendChild(script);
    });

    return scriptLoadPromise;
}

// Draws `text` as a QR inside `host`, replacing whatever was there before.
// Returns false if it couldn't (no host yet, no text, encoder not loaded) so
// the caller can fall back to showing the raw UPI string instead.
//
// Error-correction level M: a UPI string is short enough that M's redundancy
// costs little, and it reads reliably off a screen at arm's length.
export function renderQrInto(host, text, sizePx) {
    if (!host || !text || !window.QRCode) return false;

    host.innerHTML = '';
    /* eslint-disable-next-line no-new */
    new window.QRCode(host, {
        text,
        width: sizePx,
        height: sizePx,
        correctLevel: window.QRCode.CorrectLevel.M,
    });
    return true;
}
